import { render } from "./BaseSlider.vue?vue&type=template&id=374031df&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=374031df&lang=scss&scoped=true"

import exportComponent from "/builds/anteup/anteup-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374031df"]])

export default __exports__